import React from "react";
import { Route, Routes } from "react-router-dom";

import StoreDetails from "./pages/store/storeDetails";
import StorePreview from "./pages/store/storePreview";

import { setRecoil } from "recoil-nexus";
import { AllLayout } from "./pages/AllLayout";
import CheckoutDetails from "./pages/checkout/checkoutDetails";
import Login from "./pages/login/Login";
import Init from "./pages/main/Init";
import Rest from "./pages/rest";
import OrderDetails from "./pages/order/orderDetails";
import OrderHistory from "./pages/order/orderHistory";
import OrderStatus from "./pages/order/orderStatus";
import Settings from "./pages/settings/Settings";
import ApiController from "./controller/ApiController";
import MessageController from "./controller/MessageController";
import { authState, masterStoreState } from "./recoil/auth";
import { scheduleState } from "./recoil/schedule";
import { settingsState } from "./recoil/settings";
import { getDecryptObject } from "./utils/crypto";
import { APP_TYPE } from "./utils/DataType";
import Interphone from "./pages/interphone";
import InterphoneList from "./pages/interphoneList";
import MainPage from "./pages/main/mainPage";

const App = () => {
  const handleMessage = async (event: any) => {
    let message = getDecryptObject(event.data);

    if (message.type === "ping") {
      window.ReactNativeWebView?.postMessage(MessageController.getPongData());
    } else if (message.type === "set_auth") {
      console.log("set_auth!!!", message.data);
      setRecoil(authState, message.data);
      setRecoil(
        masterStoreState,
        message.data.store_list.filter((a: any) => a.store_type === 4)[0]
      );

      //todo 1. api store/getenv
      //todo 2. set env
      let response = await ApiController.store.getEnv({
        user_token_id: message.data.user_token_id,
        store_id: message.data.store_list.filter(
          (a: any) => a.store_type === 4
        )[0].store_id,
        app_type: APP_TYPE.KNOCK,
      });

      if (response && response.data) {
        const oRes = response.data;
        if (oRes.data) {
          setRecoil(settingsState, oRes.data);
          // AsyncLocalStorage.setItem("settings", JSON.stringify(oRes.data));
        }
      }
    } else if (message.type === "set_auth_env") {
      setRecoil(authState, message.data.auth);
      setRecoil(
        masterStoreState,
        message.data.auth.store_list.filter((a: any) => a.store_type === 4)[0]
      );

      setRecoil(settingsState, message.data.env);
      // showToast(JSON.stringify(message.data.env));

      // const env = getRecoil(settingsState);
      // window.ReactNativeWebView?.postMessage(
      //   MessageController.getSetEnvRequestMessage(env)
      // );
      // AsyncLocalStorage.setItem("settings", JSON.stringify(oRes.data));
    } else if (message.type === "webviewOpen") {
      window.ReactNativeWebView?.postMessage("openWebView");
    } else if (message.type === "set_schedule") {
      setRecoil(scheduleState, message.data.schedule);
    }
  };

  document.addEventListener("message", handleMessage);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* browser */}
      <Route path="/store/:store_id" element={<StorePreview />} />
      <Route element={<AllLayout />}>
        <Route path="/" element={<Init />} />
        <Route path="/rest" element={<Rest />} />

        <Route path="/:id" element={<StoreDetails />} />
        <Route path="/master" element={<MainPage />} />

        {/* DEV */}
        <Route path="/login/:id/:password/:uuid" element={<Login />} />
        <Route path="/store" element={<StoreDetails />} />
        <Route path="/history" element={<OrderHistory />} />
        <Route path="/status" element={<OrderStatus />} />
        <Route path="/order" element={<OrderDetails />} />

        <Route path="/checkout" element={<CheckoutDetails />} />

        <Route path="/interphone" element={<Interphone />} />
        <Route path="/interphone/list" element={<InterphoneList />} />

        <Route path="/settings" element={<Settings />} />
      </Route>
    </Routes>
  );
};

export default App;
